const axios = require('axios').default;
let API_URL = process.env.PLAN_MANAGER_API_URL || process.env.REACT_APP_PLAN_MANAGER_API_URL || "https://plan-manager-api.centivo.dev/";
let API_KEY = process.env.PLAN_MANAGER_API_KEY;
const facilSearch = require('./static/facilitysearch.json');

class PlanManagerClient {
    constructor(apiUrl = API_URL, apiKey = API_KEY) {
        API_URL = apiUrl;
        API_KEY = apiKey;
    }

    async getAllPlans() {
        try {
            const response = await axios.get(`${API_URL}plans/getAllPlans`, {
                headers: {
                    Authorization: API_KEY,
                    'content-type': 'application/json'
                }
            });
            if (response.status !== 200) {
                return null;
            }
            return response.data
        } catch (error) {
            console.log("PLAN MANAGER API ERROR:", error);
            return null;
        }
    }

    /**
     * @param {*} clientId 
     * @param {*} planId 
     */
    async getPlanConfigV1(clientId, planId) {
        try {
            const response = await axios.get(`${API_URL}plans/getLegacyPlanConfig?clientId=${clientId}&planId=${planId}`, {
                headers: {
                    Authorization: API_KEY,
                    'content-type': 'application/json'
                }
            });
            if (response.status !== 200) {
                return null;
            }
            return response.data
        } catch (error) {
            console.log("PLAN MANAGER API ERROR:", error);
            return null;
        }
    }

    /**
     * @param {*} clientId 
     * @param {*} planId  
     */
    async getPlanNetworks(clientId, planId) {
        try {
            const response = await axios.get(`${API_URL}plans/getPlanNetworks?clientId=${clientId}&planId=${planId}`, {
                headers: {
                    'content-type': 'application/json'
                }
            });
            if (response.status !== 200) {
                return null;
            }
            return response.data
        } catch (error) {
            console.log("PLAN MANAGER API ERROR:", error);
            return null;
        }
    }

    /**
     * @param {*} planUuid 
     * aggregate parser for planuuid
    */
    async getPlanByUuid(planUuid) {
        return await this.getPlan(planUuid.split('#')[0], planUuid.split('#')[1]);
    }

    /**
     * @param {*} clientId 
     * @param {*} planId  
     */
    async getPlan(clientId, planId) {
        try {
            const response = await axios.get(`${API_URL}plans/getInternalMedicalPlan?clientId=${clientId}&planId=${planId}`, {
                headers: {
                    Authorization: API_KEY,
                    'content-type': 'application/json'
                }
            });
            if (response.status !== 200) {
                return null;
            }
            return response.data
        } catch (error) {
            console.log("PLAN MANAGER API ERROR:", JSON.stringify(error));
            return null;
        }
    }

    getConfigMap() {
        return {
            "EMP": "Employee Only",
            "ECH": "Employee + Children",
            "ESP": "Employee + Spouse",
            "FAM": "Family"
        }
    }

    getSpecialtyFacilitySearch() {
        return facilSearch;
    }

    /**
     * @param {*} planUuid 
     * aggregate parser for planuuid
    */
    getClientIdAndPlanIdFromPlanUuid(planUuid) {
        return {
            clientId: planUuid.split('#')[0],
            planId: planUuid.split('#')[1]
        }
    }

    /**
     * @param {*} planUuid 
     * aggregate parser for planuuid
    */
    getClientIdAndPlanIdFromMember(member) {
        return this.getClientIdAndPlanIdFromPlanUuid(member.planUuid);
    }

    async isInNetwork(network, clientId, planId) {
        try {
            const result = await this.getPlanNetworks(clientId, planId);
            if (result && result.networkIndicators) {
                if (result.networkIndicators.find(item => item.networkName != null
                    && item.networkName.toString().toLowerCase() === network.toString().toLowerCase())) {
                    return true;
                }
            }
        } catch (e) { console.log("IS IN NETWORK FAILURE:", e); return null; }
        return false;
    }

    IN_NETWORK_MEMORY = {};
    async isInNetworkMemoryCaching(network, clientId, planId) {
        const cacheKey = `${network}#${clientId}#${planId}`;
        if (this.IN_NETWORK_MEMORY[cacheKey] != null) {
            return this.IN_NETWORK_MEMORY[cacheKey];
        }

        const result = await this.isInNetwork(network, clientId, planId);
        if (result != null) {
            this.IN_NETWORK_MEMORY[cacheKey] = result;
        }
        return result;
    }

    async getDefaultNotificationConfig() {
        try {
            const response = await axios.get(`${API_URL}plans/getDefaultNotificationConfig`, {
                headers: {
                    Authorization: API_KEY,
                    'content-type': 'application/json'
                }
            });
            if (response.status !== 200) {
                return null;
            }
            return response.data
        } catch (error) {
            console.log("PLAN MANAGER API ERROR:", error);
            return null;
        }
    }

}

module.exports = {
    PlanManagerClient,
    planManagerClient: new PlanManagerClient()
}
